// extracted by mini-css-extract-plugin
export default {"login-form_input":"styles_login-form_input__dL9EY"};